var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"handle",staticClass:"workflow__handle",class:[
    ("workflow__handle-" + _vm.position),
    ("workflow__handle-" + _vm.handleId),
    _vm.noDragClassName,
    _vm.noPanClassName,
    _vm.type,
    {
      connectable: _vm.isConnectable,
      connecting: _vm.isClickConnecting,
      connectablestart: _vm.isConnectableStart,
      connectableend: _vm.isConnectableEnd,
      connectionindicator:
        _vm.isConnectable &&
        ((_vm.isConnectableStart && !_vm.isConnecting) ||
          (_vm.isConnectableEnd && _vm.isConnecting)),

      'workflow__handle--disabled': _vm.disabled
    }
  ],attrs:{"data-id":(_vm.flowId + "-" + _vm.nodeId + "-" + _vm.handleId + "-" + _vm.type),"data-handleid":_vm.handleId,"data-nodeid":_vm.nodeId,"data-handlepos":_vm.position},on:{"mousedown":_vm.onPointerDown,"&touchstart":function($event){return _vm.onPointerDown($event)},"click":_vm.onClick}},[_vm._t("default",null,{"id":_vm.id})],2)}
var staticRenderFns = []

export { render, staticRenderFns }